import { createReducer } from '@reduxjs/toolkit';
import {
  createAiCharacterObjection,
  createAiLearnerGoal,
  deleteAiCharacterObjection,
  deleteAiLearnerGoal,
  getAiRolePlaySubmission,
  setAiRolePlaySubmissionCompleted,
  updateAiCharacterObjection,
  updateAiLearnerGoal,
} from 'redux/actions/ai-role-play';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(createAiCharacterObjection.fulfilled, (state, action) => {
      const { aiRolePlayId, id, text } = action.payload;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        aiRolePlay.aiCharacterObjections = [
          ...aiRolePlay.aiCharacterObjections,
          { id, text },
        ];
      }
    })
    .addCase(updateAiCharacterObjection.fulfilled, (state, action) => {
      const { aiRolePlayId, id, text } = action.payload;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        const index = aiRolePlay.aiCharacterObjections.findIndex(
          objection => objection.id === id,
        );
        if (index !== -1) {
          aiRolePlay.aiCharacterObjections[index].text = text;
        }
      }
    })
    .addCase(deleteAiCharacterObjection.fulfilled, (state, action) => {
      const { aiCharacterObjectionId, aiRolePlayId } = action.meta.arg;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        aiRolePlay.aiCharacterObjections = aiRolePlay.aiCharacterObjections.filter(
          objection => objection.id !== aiCharacterObjectionId,
        );
      }
    })
    .addCase(createAiLearnerGoal.fulfilled, (state, action) => {
      const { aiRolePlayId, id, text } = action.payload;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        aiRolePlay.aiLearnerGoals = [
          ...aiRolePlay.aiLearnerGoals,
          { id, text },
        ];
      }
    })
    .addCase(updateAiLearnerGoal.fulfilled, (state, action) => {
      const { aiRolePlayId, id, text } = action.payload;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        const index = aiRolePlay.aiLearnerGoals.findIndex(
          goal => goal.id === id,
        );
        if (index !== -1) {
          aiRolePlay.aiLearnerGoals[index].text = text;
        }
      }
    })
    .addCase(deleteAiLearnerGoal.fulfilled, (state, action) => {
      const { aiLearnerGoalId, aiRolePlayId } = action.meta.arg;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        aiRolePlay.aiLearnerGoals = aiRolePlay.aiLearnerGoals.filter(
          goal => goal.id !== aiLearnerGoalId,
        );
      }
    })
    .addCase(getAiRolePlaySubmission.fulfilled, (state, action) => {
      const submission = action.payload.result;
      const aiRolePlay = state.models.aiRolePlays[submission.aiRolePlay.id];
      if (aiRolePlay) {
        state.models.aiRolePlaySubmissions[submission.id] = submission;
        aiRolePlay.submissionId = submission.id;
        aiRolePlay.pointsReceived = submission.pointsReceived;
      }
    })
    .addCase(setAiRolePlaySubmissionCompleted, (state, action) => {
      const { aiRolePlayId, aiRolePlaySubmissionId, pointsReceived, completedAt } = action.payload;
      const aiRolePlay = state.models.aiRolePlays[aiRolePlayId];
      if (aiRolePlay) {
        aiRolePlay.submissionId = aiRolePlaySubmissionId;
        aiRolePlay.pointsReceived = pointsReceived;
        aiRolePlay.progress = 'completed';
      }
      const submission = state.models.aiRolePlaySubmissions[aiRolePlaySubmissionId];
      if (submission) {
        submission.pointsReceived = pointsReceived;
        submission.completedAt = completedAt;
      } else {
        state.models.aiRolePlaySubmissions[aiRolePlaySubmissionId] = {
          id: aiRolePlaySubmissionId,
          pointsReceived,
          completedAt,
          status: null,
          attemptNumber: null,
          createdAt: null,
          updatedAt: null,
          openingNarrative: null,
          leaderboardRank: null,
          leaderboardPoints: null,
          priorLeaderboardRank: null,
          feedback: null,
          aiRolePlay: { id: aiRolePlayId },
        };
      }
    });
});
